// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5e-2";
export var blackBorderOnHover = "_5e-7";
export var cell = "_5e-6";
export var cellContainer = "_5e-3";
export var checked = "_5e-8";
export var disabled = "_5e-5";
export var featuredIconCellContainer = "_5e-9";
export var featuredIconTextContainer = "_5e-b";
export var featuredIconWrapper = "_5e-a";
export var noBorder = "_5e-c";
export var orangeSelectedRow = "_ej-3";
export var overflowableText = "_5e-0";
export var overflowableTextContainer = "_5e-1";
export var row = "_5f-0";
export var rowCheckboxCell = "_5e-4";
export var selectableTable = "_ej-2";